/* eslint-disable brace-style */
import type {
  IRicosToolbar,
  IToolbarItemConfigTiptap,
  IToolbarSettings,
  PublisherProvider,
  ToolbarButtonRenderers,
  ToolbarType,
} from './../../ricos-types';
import { TOOLBARS } from './../../editor-common';

import type { Topics } from '../topics';
import type { ToolbarServices } from '../types';

export class RicosToolbar<Type extends ToolbarType> implements IRicosToolbar<Type> {
  readonly type: Type;

  protected settings: IToolbarSettings<Type>;

  protected services: ToolbarServices;

  protected isMobile: boolean;

  private publishers!: PublisherProvider<Topics>;

  constructor(
    isMobile: boolean,
    services: ToolbarServices,
    type: Type,
    publishers: PublisherProvider<Topics>,
    settings: IToolbarSettings<Type>
  ) {
    this.type = type;
    this.publishers = publishers;
    this.services = services;
    this.isMobile = isMobile;
    this.settings = settings;
  }

  isVisible(): boolean {
    return true;
  }

  getMegaToolbarItemsConfig(): IToolbarItemConfigTiptap[] {
    console.error('getToolbarItemsConfig is not implemented for type ' + this.type);
    return [];
  }

  isEmpty = () => this.type === TOOLBARS.EMPTY;

  getToolbarItemsConfig(): IToolbarItemConfigTiptap[] {
    console.error('getToolbarItemsConfig is not implemented for type ' + this.type);
    return [];
  }

  getToolbarItemsRenderers(
    _referenceElement?: HTMLElement | null | undefined
  ): ToolbarButtonRenderers {
    console.error('getToolbarItemsRenderers is not implemented for type ' + this.type);
    return {};
  }

  getSettings() {
    return this.settings;
  }

  publishButtonClick(buttonId: string) {
    return this.publishers
      .byTopic('ricos.toolbars.functionality.buttonClick')
      .publish({ toolbarType: this.type, buttonId });
  }

  publishSearch(search: string) {
    return this.publishers
      .byTopic('ricos.toolbars.functionality.search')
      .publish({ toolbarType: this.type, search });
  }

  publishInstanceLoaded() {
    return this.publishers
      .byTopic('ricos.toolbars.instance.loaded')
      .publish({ toolbarType: this.type });
  }
}
